import ApiService from "./ApiService";

const SubscriptionService = {
    getPlans() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/plans').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    createSubscription(data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/subscription/create', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    deleteSubcription() {
        return new Promise((resolve, reject) => {
            ApiService.delete('/subscription/delete').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    changePlan(planId) {
        return new Promise((resolve, reject) => {
            ApiService.put('/subscription/change-plan', { plan_id: planId }).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    }
};

export default SubscriptionService
